import moment from "moment";
import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { get_claims } from "../../actions/shipmentNPayment";
import Table from "../../common/Table";
import { NavWrap, TableWrap } from "../ShopForTyres";

const Claims = () => {
  const data = useSelector(
    (state) => state?.claims?.get_claims?.data?.claim_list
  );
  const dispatch = useDispatch();
  const history = useHistory();
  const permissions = JSON.parse(localStorage.getItem("permissions") || "{}");
  useEffect(() => {
    dispatch(
      get_claims({
        email: localStorage.getItem("email"),
        customer_number: "400002",
      })
    );
    // eslint-disable-next-line
  }, []);
  const dc = [
    { label: "Highway", value: "A" },
    { label: "Off Road", value: "B" },
    { label: "City (Urban)", value: "C" },
    { label: "Mixed", value: "D" },
  ];
  const columns = [
    {
      header: "Claim ID",
      accessor: "Vbeln",
      width: 17,
    },
    {
      header: "Claim Reason",
      accessor: "ZzclaimReason",
      width: 17,
      cell: (row) => `${row.ZzclaimReason || row.ClaimDesc}`,
    },
    {
      header: "Claim Date",
      accessor: "Erdat",
      width: 17,
      cell: (row) => {
        return row.Erdat && !row.Erdat.includes("0000")
          ? moment(row.Erdat, "DD.MM.YYYY").format("MM/DD/YY")
          : "";
      },
    },
    {
      header: "Claim Status",
      accessor: "Clstatus",
      width: 17,
    },
    // {
    //   header: "Order Type",
    //   accessor: "vtweg",
    //   width: 8,
    //   cell: (row) => (row.vtweg === "41" ? "FTL" : "FD"),
    // },
    {
      header: "Driving Condition",
      accessor: "DrivingCondition",
      width: 17,
      cell: (row) =>
        `${dc.find((e) => e.value === row.DrivingCondition)?.label || "-"}`,
    },
    {
      header: "Vehicle Category",
      accessor: "Vehiclecat",
      width: 17,
      // cell: (row) => `${row.Street}, ${row.Pstlz}`
    },
    {
      header: "Address",
      accessor: "Kunnr",
      width: 15,
      cell: (row) =>
        `${row.Name1}${row.Name1 ? ", " : ""}${row.Street}${
          row.Street ? ", " : ""
        }${row.Ort01}${row.Ort01 ? ", " : ""}${row.Pstlz}`,
    },
  ];

  // ✅ Filter claims list based on permissions
  const filteredData = React.useMemo(() => {
    if (!data) return [];
    if (permissions?.claims?.full_access || permissions?.claims?.view) {
      // delegate user → only claims where Kunn2 is allowed
      return data.filter((claim) =>
        (permissions?.claims?.shipment_code || []).includes(claim.Kunn2)
      );
    }
    // normal user → all claims
    return data;
  }, [data, permissions]);

  return (
    <div className="shop-tyres">
      <NavWrap>
        <TableWrap
          isFilter={false}
          showBulk={false}
          name={"Claims"}
          showGrid={false}
          searchPlaceholder={"Search by claim id..."}
          callSearch={(search) => {
            let obj = {
              email: localStorage.getItem("email"),
            };

            dispatch(
              get_claims({ ...obj, page: 1, limit: 10, search_key: search })
            );
          }}
          // namedFilters={["All (27)", "Open (12)", "Pending (14)", "Paid (1)"]}
          createBtn={true}
          createText={"New Claim"}
          to={"/new-claim"}
        >
          <Table
            columns={columns}
            data={filteredData}
            action={false}
            actionWidth={8}
            onRowClick={(row) => {
              history.push("/view-claim/" + row.Vbeln);
            }}
          />
        </TableWrap>
      </NavWrap>
    </div>
  );
};

export default Claims;
